"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FilterTriggerButton = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../../../utils");
var TriggerButtonBase_1 = require("../TriggerButtonBase");
var FilterTriggerButton_module_scss_1 = __importDefault(require("./FilterTriggerButton.module.scss"));
var FilterTriggerButton = function (_a) {
    var selectedOptionLabels = _a.selectedOptionLabels, label = _a.label, classNameOverride = _a.classNameOverride, _b = _a.labelCharacterLimitBeforeTruncate, labelCharacterLimitBeforeTruncate = _b === void 0 ? 50 : _b;
    var hasSelectedValues = selectedOptionLabels.length > 0;
    return (react_1["default"].createElement(TriggerButtonBase_1.TriggerButtonBase, { classNameOverride: classNameOverride },
        react_1["default"].createElement("span", { className: hasSelectedValues ? FilterTriggerButton_module_scss_1["default"].hasSelectedValues : "" }, label),
        hasSelectedValues && (react_1["default"].createElement("span", null, ": ".concat((0, utils_1.getTruncatedLabels)(selectedOptionLabels, labelCharacterLimitBeforeTruncate))))));
};
exports.FilterTriggerButton = FilterTriggerButton;
exports.FilterTriggerButton.displayName = "FilterTriggerButton";
//# sourceMappingURL=FilterTriggerButton.js.map